import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eAccBienLaiThietLapActionIds,
  IAccBienLaiThietLapActionTypes,
} from "../../action-types/category/IBienLaiThietLapActions";
import { IAccBienLaiThietLap } from "../../../model/respone/category/IAccBienLaiThietLap";
import { bienLaiThietLapApi } from "../../../api/category/bienLaiThietLapApi";

export function* bienLaiThietLapSaga(): any {
  yield takeLatest(eAccBienLaiThietLapActionIds.LOAD_START, loadWorker);
  yield takeEvery(eAccBienLaiThietLapActionIds.SAVE_START, saveWorker);
  yield takeEvery(eAccBienLaiThietLapActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(bienLaiThietLapApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.bienLaiThietLap.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.bienLaiThietLap.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
function* saveWorker(action: IAccBienLaiThietLapActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IAccBienLaiThietLap;
  if (payload.id_thiet_lap > 0) {
    res = yield call(bienLaiThietLapApi.Update, payload);
  } else {
    res = yield call(bienLaiThietLapApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.bienLaiThietLap.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.category.bienLaiThietLap.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* deleteWorker(action: IAccBienLaiThietLapActionTypes): any {
  const res: IBaseRespone = yield call(
    bienLaiThietLapApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.category.bienLaiThietLap.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.bienLaiThietLap.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}
